import React, {useEffect, useRef, useState} from 'react';
import {withStyles} from '@material-ui/core/styles'
import {Badge, Button, ButtonGroup, Collapse, Paper, Table, TableContainer,} from '@material-ui/core';

import DataFilters from "./DataFilters";
import DataSearch from "./DataSearch";
import DataPagination from "./DataPagination";
import ColumnControls from "./ColumnControls";
import ViewModeControl from "./ViewModeControl";
import DataListView from "./list-view/DataListView";
import DataIconView from "./icon-view/DataIconView";
import DataStreamView from "./stream-view/DataStreamView";
import {ColumnsIcon, FilterIcon} from '../../../helpers/Icons'
import TableSortHeader from "./TableSortHeader";
import SortControl from "./SortControl";
import SelectAllControl from "./SelectAllControl";
import Loader from "../../organisms/loader/Loader";
import IconSizeControl from "./IconSizeControl";

const styles = {
  tableToolbar: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    flexGrow: 0,
    gap:'0.5em',
    alignSelf: 'self-start',
  },
  toolbarMenu: {
    flexWrap:'wrap',
    margin: '1px 0 0 1px',
    '& > button':{
      margin: '-1px 0 0 -1px',
      borderColor: '#c4c4c4',
      flexBasis:'min-content',
      flexGrow:1
    },
    '& > button:not(:last-child)':{
      borderColor: '#c4c4c4'
    }
  },
  toolbarButton: {
    padding: '5.1px 10.2px',
    fontSize: '0.7225em',
    height: '34px',
    backgroundColor: '#ffffff',
    '& span:first-child > span:first-child':{
      marginLeft: '-3.4px',
      marginRight: '6.8px'
    },
    '& svg':{
      width: '1em',
      height: '1em',
    }
  },
  toolbarButtonOpen: {
    padding: '5.1px 10.2px',
    color: '#267ea6',
    borderColor: '#267ea6',
    backgroundColor: '#f6f6f6',
    fontSize: '0.7225em',
    height: '34px',
    '& span:first-child > span:first-child':{
      marginLeft: '-3.4px',
      marginRight: '6.8px'
    },
    '& svg':{
      width: '1em',
      height: '1em',
    }
  },
  tableWrapper:{
    position: 'relative',
  },
  dataTable: {
    '& td': {
      padding: '4px 4px 4px 8px'
    },
    '& th': {
      padding: '8px 4px 8px 8px',
      borderBottom: '1px solid #bbb',
      lineHeight:'1.25em',
      height:'48px',
      minHeight:'48px',
      boxSizing: 'border-box',
      backgroundColor: '#f8f8f8'
    },
    '& th:first-child': {
      paddingLeft: '1em'
    },
    '& td:first-child': {
      paddingLeft: '1em'
    },
    '& td:not(:first-child)': {
      paddingLeft: '7px',
      borderLeft: '1px solid rgba(0,0,0,0)'
    },
    '& tr:hover': {
      backgroundColor: "rgba(16, 175, 255, 0.12)",
      '& > td:not(:first-child)': {
        borderLeft: '1px solid rgba(0, 89, 133, 0.12)'
      },
    },
    '& thead': {
      border: '1px solid #ddd',
      borderBottom: '1px solid #bbb',
    }
  },
  noItems:{
    fontStyle:'italic',
    opacity:0.5,
    fontSize:'1rem',
    margin: '0.5rem auto',
    textAlign: 'center'
  },
  loadingWrapper:{
    position: 'absolute',
    top: 0,
    width: '100%',
    height: '100%',
    verticalAlign: 'middle',
    padding: '1em',
    background: '#fffd',
    boxSizing: 'border-box',
    zIndex: 20
  },
  loading: {
    width: '50%',
    margin: '2em auto 0',
    textAlign: 'center',
    position: 'sticky',
    top: '5em',
  },
  loadingPlaceholder:{

  }
};

function DataTable(props) {
  const {
    fetchItems, columns, columnMap, itemList, itemMap, itemCount,
    controller, setController, mapBounds, mindfileUserLevel,
    selectedIds, setSelectedIds, selectedItems, setSelectedItems,
    removeItems, moveItems, folderList, addFolder,
    filters, filterSelections, clearFilterSelections, addFilterSelectByName, mindfileFilterValues,
    viewMode, setViewMode, viewModeOptions,
    iconSize, setIconSize, iconSizeOptions,
    tableToolbar, selectedToolbar, openDataView,
    filtersOpen, setFiltersOpen,
    columnsOpen, setColumnsOpen, visibleColumns, setVisibleColumns,
    loading, saveItems, viewOptsLoaded, bindViewOptions, getMindfileItem,
    mindfileDisplay, primaryMindfile, classes
  } = props;
  const hasIconSize = !!iconSize && !!setIconSize && !! iconSizeOptions;
  const [searchText, setSearchText] = useState('');
  const tableRef = useRef(null);

  const [orders_f, orders_d, orders_n] = [controller.orders[0].f, controller.orders[0].d, controller.orders[0].n]
  useEffect(() => {
      if(viewOptsLoaded) {
        fetchItems();
      }
    },
    // eslint-disable-next-line
    [controller.page, controller.rowsPerPage, orders_f, orders_d, orders_n, controller.search, mapBounds, filterSelections, viewOptsLoaded]
  );

  useEffect(() => {
      document.getElementById('pageJumpField').value = controller.page;
    }, [controller.page]);

  useEffect(() => {
      if(loading && !!tableRef){
        const top = tableRef.current.getBoundingClientRect().top;
        if(top < 0) {
          tableRef.current.scrollIntoView({behavior: 'smooth', block: 'start'});
        }
      }
    }, [loading, tableRef]);

  // useEffect(() => {
  //   console.log(itemMap, selectedItems, selectedIds)
  //   setSelectedIds([...selectedIds.filter(id => !!itemMap[id])])
  //   const items = Object.entries(selectedItems).filter((id,item) => !!itemMap[id]);
  //   setSelectedItems(Object.fromEntries(items));
  // }, [itemMap]);

  const handlePageChange = (event, page) => {
    // let maxPage = Math.max(1, Math.ceil(itemCount / controller.rowsPerPage));
    let maxPage = Math.max(1, !itemCount ? page : Math.ceil(itemCount / controller.rowsPerPage));
    let newPage = Math.min(Math.max(1, page), maxPage);
    if(newPage === controller.page){
      return;
    }
    setController((prevState, props) =>({
      ...prevState.controller,
      page: newPage
    }));
    // setSelectedIds([]);
  };

  const handlePageJump = (event) => {
    const val = parseInt(document.getElementById('pageJumpField').value, 10);
    if(isNaN(val)){
      document.getElementById('pageJumpField').value = controller.page;
      return;
    }
    const maxPage = Math.max(1, !itemCount ? val : Math.ceil(itemCount / controller.rowsPerPage));
    const newPage = Math.min(Math.max(1, val), maxPage);
    document.getElementById('pageJumpField').value = newPage;
    handlePageChange(event, newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    const newRows = parseInt(event.target.value);
    // const itemFirst = Math.min(itemCount, ((controller.page - 1) * controller.rowsPerPage) + 1);
    let itemFirst = Math.max(0, ((controller.page - 1) * controller.rowsPerPage) + 1);
    if(!!itemCount){
      itemFirst = Math.min(itemCount, itemFirst);
    }
    const page = Math.floor(itemFirst / newRows) + 1;
    // let maxPage = Math.max(1, Math.ceil(itemCount / newRows));
    let maxPage = Math.max(1, !itemCount ? page : Math.ceil(itemCount /newRows));
    let newPage = Math.min(Math.max(1, page), maxPage);
    setController((prevState, props) => ({
      ...prevState.controller,
      rowsPerPage: newRows,
      page: newPage
    }));
    // setSelectedIds([]);
  };

  const handleOrderChange = (order, defAsc=true, asc=null) => {
    if(order === null){
      return;
    }
    const firstOrder = controller.orders[0];
    let order_asc = asc !== null ? asc : (firstOrder.f !== order ? defAsc : !firstOrder.d)
    let nullSort = true;
    const column = columns.map((column) => (Array.isArray(column.header) ? column.header : [column.header]))
      .flat().find(opt => opt.sort === order);
    if(column.nulls) {
      nullSort = !(firstOrder.f === order && firstOrder.d !== defAsc && order_asc === defAsc);
      if (firstOrder.f === order && firstOrder.hasOwnProperty('n') && !firstOrder.n && order_asc !== defAsc) {
        order_asc = defAsc;
        nullSort = true;
      }
    }
    setController((prevState, props) => ({
      ...prevState.controller,
      orders: [{f:order, d:order_asc, n:nullSort}],
      page: 1
    }));
    // setSelectedIds([]);
  };

  const handleKeyDown = (callbacks, event) => {
    for (let i=0; i<callbacks.length; i++){
      let cb = callbacks[i];
      if (event.which === cb.key || event.keyCode === cb.key) {
        cb.action();
        return true;
      }
    }
    return false;
  };


  const pageSelected = () => {
    const selCount = Object.keys(selectedItems).length;
    if(selCount === 0){
      return -1;
    }else if(selCount < itemList.length){
      return 0;
    }
    for(let i=0; i<itemList.length; i++){
      let item = itemList[i];
      if(!selectedItems[item.id]){
        return 0;
      }
    }
    return 1;
  }
  const selectAllState = pageSelected();

  const onSelectAllClick = () => {
    if(setSelectedItems === null || setSelectedIds === null){
      return;
    }
    if(selectAllState !== 1){
      setSelectedIds([selectedIds, ...itemList.map(item => item.id)]);
      setSelectedItems({...selectedItems,...itemMap});
    }else{
      setSelectedIds([]);
      setSelectedItems({});
    }
  }
  const onSelectItem = (item, e) => {
    if(setSelectedItems === null || setSelectedIds === null){
      return;
    }
    if(!!selectedItems[item.id]){
      setSelectedIds(selectedIds.filter(id => id !== item.id));
      // eslint-disable-next-line
      const { [item.id]:{}={}, ...newSelectedItems} = selectedItems;
      setSelectedItems(newSelectedItems);
    }else{
      setSelectedIds([...selectedIds, item.id]);
      setSelectedItems({...selectedItems, [item.id]:item});
    }
  };

  const handleSearchChange = (e) => {
    setController((prevState, props) => ({
      ...prevState.controller,
      search: searchText,
      page: 1
    }));
    // setSelectedIds([]);
  };

  const clearSearch = (e) => {
    setSearchText('');
    if(controller.search !== '' && controller.search !== null){
      setController((prevState, props) => ({
        ...prevState.controller,
        search: '',
        page: 1
      }));
      // setSelectedIds([]);
    }
  };

  const toggleColumnVisibility = (key) => {
    if(!visibleColumns.hasOwnProperty(key)){
      return;
    }
    setVisibleColumns({...visibleColumns, [key]: !visibleColumns[key]});
  }

  const columnDiffCount = columns.filter(col => col.enabled).filter(c => (visibleColumns[c.key] !== !c.hidden)).length;
  const filterDiffCount = filters.filter((f,index) => (f.enabled && f.visible && filterSelections[index].selectedItems.length > 0)).length;

  return (
    <div>
      <div style={{display: 'flex', flexDirection: 'row', flexWrap: 'wrap-reverse', gap: '0.5em'}}>
        <div className={classes.tableToolbar}>
          {viewModeOptions.length > 1 ?
            <ViewModeControl
              viewMode={viewMode}
              setViewMode={setViewMode}
              viewModeOptions={viewModeOptions}
            />
            : null
          }
          {viewMode === 'Icon' && hasIconSize ?
            <IconSizeControl
              iconSize={iconSize}
              setIconSize={setIconSize}
              iconSizeOptions={iconSizeOptions}
            />
            : null
          }
          <ButtonGroup variant="outlined" className={classes.toolbarMenu} style={{flexWrap:'wrap', flexGrow:1}}>
            {viewMode === 'List' ?
              <Button
                id="openColumns"
                variant="outlined"
                className={columnsOpen ? classes.toolbarButtonOpen : classes.toolbarButton}
                onClick={() => setColumnsOpen(!columnsOpen)}
                startIcon={<ColumnsIcon size="small"/>}
              >
                <Badge id="columnsActiveCount" badgeContent={columnDiffCount} color="secondary" overlap="rectangular">
                  Columns
                </Badge>
              </Button>
              : null
            }
            {!!filters && filters.length > 0 ?
              <Button variant="outlined"
                      id="openFilters"
                      className={filtersOpen ? classes.toolbarButtonOpen : classes.toolbarButton}
                      onClick={() => setFiltersOpen(!filtersOpen)}
                      startIcon={<FilterIcon/>}
              >
                <Badge id="filtersActiveCount" badgeContent={filterDiffCount} color="secondary" overlap="rectangular">
                  Filters
                </Badge>
              </Button>
              : null
            }
            {tableToolbar.filter(tool => !!tool.button).map((tool) => (
              <Button variant="outlined"
                  id={tool.button.key}
                  key={tool.button.key}
                  className={tool.button.open ? classes.toolbarButtonOpen : classes.toolbarButton}
                  onClick={tool.button.action}
                  startIcon={tool.button.startIcon}
              >
                {tool.button.label}
              </Button>
            ))}
          </ButtonGroup>
        </div>
        <div style={{flexGrow: 100, alignSelf:'end'}}>
          <DataSearch
            searchText={searchText}
            setSearchText={(txt) => {
              setSearchText(txt);
              if(txt === ""){
                clearSearch();
              }
            }}
            clearSearch={clearSearch}
            handleSearchChange={handleSearchChange}
            handleSearchChangeKeyDown={handleKeyDown.bind(this, [{key:13, action:handleSearchChange},{key:27, action:clearSearch}])}
          />
        </div>
      </div>
      <div style={{display: 'flex', flexDirection: 'column'}}>
        {viewMode === 'List' ?
          <Collapse in={columnsOpen} timeout="auto" unmountOnExit>
            <ColumnControls
              open={columnsOpen}
              setOpen={setColumnsOpen}
              columns={columns}
              visibleColumns={visibleColumns}
              toggleColumnVisibility={toggleColumnVisibility}
              setVisibleColumns={setVisibleColumns}
            />
          </Collapse>
          : null
        }
        {!!filters && filters.length > 0 ?
          <Collapse in={filtersOpen} timeout="auto" unmountOnExit>
            <DataFilters
              open={filtersOpen}
              setOpen={setFiltersOpen}
              filters={filters}
              filterSelections={filterSelections}
              clearFilterSelections={clearFilterSelections}
              mindfileFilterValues={mindfileFilterValues}
            />
          </Collapse>
          : null
        }
      </div>
      <div style={{display: 'flex', flexDirection: 'row', flexWrap:'wrap-reverse', marginTop:'0.5em', gap:'0.5em'}}>
        <div style={{display: 'flex', flexDirection: 'row', flexWrap:'wrap', gap:'0.5em'}}>
          {setSelectedItems === null || setSelectedIds === null || mindfileUserLevel > 2 ? null :
            <SelectAllControl
              itemList={itemList}
              selectedIds={selectedIds}
              selectedItems={selectedItems}
              selectAllState={selectAllState}
              onSelectAllClick={onSelectAllClick}
            />
          }
          <SortControl
            columns={columns}
            controller={controller}
            handleOrderChange={handleOrderChange}
          />
        </div>
        {bindViewOptions}
      </div>
      {tableToolbar.filter(tool => !!tool.panel).map((tool) => tool.panel)}
      <div ref={tableRef} className={classes.tableWrapper}>
        <Paper style={{marginTop: '1em'}}>
          {selectedToolbar}
          {viewMode === 'List' ?
            <div id="dataTableContainer">
              <TableContainer style={{overflowX:'auto', overflowY:'hidden', overscrollBehaviorX:'contain', overscrollBehaviorY:'auto'}}>
                <Table id="dataTableListView" className={classes.dataTable}>
                  <TableSortHeader
                    columns={columns}
                    controller={controller}
                    itemList={itemList}
                    selectedItems={selectedItems}
                    selectAllState={selectAllState}
                    visibleColumns={visibleColumns}
                    handleOrderChange={handleOrderChange}
                    onSelectAllClick={onSelectAllClick}
                    mindfileUserLevel={mindfileUserLevel}
                  />
                  <DataListView
                    columns={columns}
                    visibleColumns={visibleColumns}
                    itemList={itemList}
                    selectedItems={selectedItems}
                    onSelectItem={onSelectItem}
                    openDataView={openDataView}
                    mindfileUserLevel={mindfileUserLevel}
                  />
                </Table>
              </TableContainer>
            </div>
            : null
          }
        </Paper>
        {viewMode === 'Icon' ?
          <div id="dataTableContainer">
            <DataIconView
              iconSize={iconSize}
              itemList={itemList}
              columnMap={columnMap}
              selectedItems={selectedItems}
              onSelectItem={onSelectItem}
              openDataView={openDataView}
              saveItems={saveItems}
              moveItems={moveItems}
              removeItems={removeItems}
              folderList={folderList}
              addFolder={addFolder}
              mindfileFilterValues={mindfileFilterValues}
              mindfileUserLevel={mindfileUserLevel}
              mindfileDisplay={!primaryMindfile ? mindfileDisplay : null}
            />
          </div>
          : null}
        {viewMode === 'Stream' ?
          <div id="dataTableContainer">
            <DataStreamView
              itemList={itemList}
              columnMap={columnMap}
              selectedItems={selectedItems}
              onSelectItem={onSelectItem}
              openDataView={openDataView}
              saveItems={saveItems}
              moveItems={moveItems}
              removeItems={removeItems}
              folderList={folderList}
              addFolder={addFolder}
              mindfileFilterValues={mindfileFilterValues}
              mindfileUserLevel={mindfileUserLevel}
              getMindfileItem={getMindfileItem}
              mindfileDisplay={mindfileDisplay}
              itemChangeCallback={fetchItems}
              addFilterSelectByName={addFilterSelectByName}
            />
          </div>
          : null}
        {itemList.length === 0 ? <div id="noDataFound" className={classes.noItems}>No Items Found</div> : null}
        {loading ? <div className={classes.loadingWrapper}><div id="dataLoader" className={classes.loading}><Loader text="Loading" /></div></div> : null }
      </div>
      <DataPagination
        controller={controller}
        itemsTotal={itemCount}
        pageItemCount={itemList.length}
        handlePageChange={handlePageChange}
        handlePageJump={handlePageJump}
        handlePageJumpKeyDown={handleKeyDown.bind(this, [{key:13, action:handlePageJump}])}
        handleChangeRowsPerPage={handleChangeRowsPerPage} />
      <div>&nbsp;</div>
    </div>
  )
}

export default withStyles(styles)(DataTable);
